export default {
  arrangementTime: '安排時間',
  tabEnd: '結束',
  tabVideo: '視頻',
  tabPaper: '試題',
  tabPaperDraw: '抽題',
  tabConference: '進入會議',
  videoStatus: {
    notStart: '未開始',
    connect: '可連接',
    interviewing: '視頻中',
    hangup: '已掛斷',
    ended: '已結束',
    checkIn: '已登入',
    online: '線上',
    offline: '離線',
  },
  conferenceTips: '會議已結束',
  joinConferenceFailedTips: '加入會議失敗',
  fraud: '舞弊',
  fraudCancel: '取消舞弊標記',
  absent: '缺考',
  absentCancel: '取消缺考標記',
  groupName: '所屬組',
  groupNumber: '編號',
  number: '{number}號',
  view: '查看',
  showHistory: '查看歷史成績',
  logout: '登出',
  interviewStatus: {
    complete: '已結束',
    interviewing: '進行中',
    waiting: '未開始',
  },
  refresh: '重繪',
  refreshSuccess: '重繪成功',
  average: '該候選人平均成績',
  score: '分',
  tipStatus: {
    interviewing: '評分進行中',
    processing: '修改成績申請中',
    unconfirmed: '管理員已拒絕修改成績申請',
    confirmed: '管理員已同意修改成績申請',
    unsubmitted: '評分調整中',
  },
  examScore: '考試成績',
  viewPaper: '查看答卷',
  fullScore: '滿分',
  minScore: '最低分',
  halfScore: '半分',
  pointLabel: '打分',
  pointPlaceholder: '請打分',
  comment: '評語',
  totalScore: '總得分',
  originalScore: '原始得分',
  historyScore: '歷史成績',
  imagePreview: '圖片預覽',
  ruleForm: {
    editReasonLabel: '修改原因',
    editReasonPlaceholder: '請輸入修改原因',
    oldScoreLabel: '原評分',
    oldScorePlaceholder: '請輸入原評分',
    newScoreLabel: '修改後的評分',
    newScorePlaceholder: '請輸入修改後的評分',
    isMasterConfirm: '裁判組長是否已同意',
    yes: '是',
    no: '否',
    confirm: '確定',
    cancel: '取消',
    modifyContent: '修改內容',
    oldTotalScore: '原總分',
    newTotalScore: '修改後總分',
    cancelApplication: '撤銷申請',
    cancelApplicationTitle: '撤銷申請',
    cancelApplicationConfirm: '確定要撤銷本次修改成績申請嗎？',
  },
  checkInTip: '該候選人尚未簽到,請先給該候選人簽到。',
  checkInButton: '簽到',
  noDataMsg: '暫無評分表',
  placeholder: {
    reason: '請輸入修改原因',
    old_score: '請輸入原評分',
    new_score: '請輸入修改後的評分',
  },
  fraudConfirmMsg: '標記舞弊後,候選人將不能被評分,成績作廢,確定標記？',
  fraudCancelMsg: '確認取消該候選人的舞弊標記？',
  absentConfirmMsg: '標記缺考後,候選人將不能被評分,成績作廢,確定標記？',
  absentCancelMsg: '確認取消該候選人的缺考標記？',
  signOutConfirmMsg: '確定退出面試評分系統？',
  signOutCancelMsg: '取消退出',
  modifyScoreConfirmMsg: '確認需要修改成績嗎？',
  modifyScoreConfirmButton: '修改成績',
  interviewingAlertMsg: '當前選手暫未打分',
  scoreMsg: ['當前候選人的分數是', '結果', '您確定提交嗎？'],
  scoreAlertMsg: '評分項“{msg}”未判分,請在所有評分項判分後提交面試結果',
  signTips: '此次修改成績後需要在清單上重新進行場次的簽字，確認修改？',
  error307: '您已被管理員結束打分,點擊確定後,將跳轉到首頁',
  error401: '登入過期,請重新登入',
  successMsg: {
    processing: '修改成績申請中,請耐心等待',
    confirmed: '管理員已同意修改成績申請',
    unconfirmed: '管理員已拒絕修改成績申請',
    // default: '出了一些問題',
  },
  applicationNotify: '申請狀態提示',
  applicationRecords: '申請記錄',
  recordColumns: {
    applyTime: '申請時間',
    oldScore: '原得分',
    newScore: '修改為',
    status: '審核狀態',
  },
  recordStatus: {
    processing: '審核中',
    confirmed: '已通過',
    confirmed_done: '已通過',
    cancelled: '已撤銷',
    unconfirmed: '已拒絕',
    unconfirmed_done: '已拒絕',
  },
  showHistoryNoData: '此候選人暫無歷史成績',
  videoOpreateStartAlert: '面試時間未到,請稍後…',
  videoOpreateEndAlert: '面試已結束,如有需要請聯系管理員',
  noPaper: '暫無試題',
  noPaperAlert: {
    title: '提示',
    msg: '當前無有效試題！',
    expired: '原內容已失效,本次將打開新的內容,新內容有效時間為:',
  },
  paperExpireAlert: {
    title: '該試題還有{time}分鐘過期。',
    confirm: '繼續播放',
    cancel: '取消播放',
    confirmPaper: '繼續操作',
    cancelPaper: '取消操作',
  },
  btnContent: {
    unsubmitted: '完成',
    waiting: '開始評分',
    interviewing: '完成',
    complete: '修改成績',
    processing: '查看申請狀態',
    confirmed: '修改成績',
    unconfirmed: '修改成績',
  },
  showPaperNoData: '尚無數據，請在考生開考後重試。',
  personalInfo: {
    姓名: '姓名',
    性别: '性别',
    客户编号: '客戶編號',
    身份证号: '身份證號',
    邮箱地址: '郵箱地址',
    手机号码: '手機號碼',
    预约时间: '預約時間',
    应聘岗位: '應聘崗位',
    毕业学校: '畢業學校',
    所在地区: '所在地區',
    照片: '照片',
    简历: '簡歷',
    报告: '報告',
    签到开始时间: '簽到開始時間',
    签到截至时间: '簽到截止時間',
    候考区: '候考區',
    面试室: '面试室',
  },
  exceedMaximumScore: '評分分值不符合預設分值。',
  period: '。',
  exitConfirm: '退出當前視像會議？',
  minScoreMsg: ['當前總得分低於最低分值', '須填寫評語。'],
  maxScoreMsg: ['當前總得分高於最高分值', '須填寫評語。'],
  groupScore: '集體評分',
  singleScore: '個人評分',
  confirmDrawPaperMsg: '確認後，系統將為本組候選人抽取面試題目。',
  drawingPaper: '系統正在抽題，請稍候……',
  drawPaperDone: '抽題完成，請查看試題。',
  drawPaperConfirmText: '查看試題',
  drawPaperCancelText: '關閉',
  moreInfo: '更多資訊',
  collapseInfo: '收起',
  noFile: '暫無檔案',
  networkError: '評分失敗！網路異常，請檢查網路狀況後重試。',
};
